import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app";

// Define a user for the slice state
interface userState {
  user_name: string;
  user_id: string;
  user_email: string;
  // allowed_models
  temp: number;
  chunk_size: number;
  search_type: string;
  chat_history: number;
  model: string;
  type: string;
  request: string;
  sendfulldoc: boolean;
  piiInfo: boolean;
  hidePageContent: boolean;
}

// Define the initial state using that user
const initialState: userState = {
  user_name: "",
  user_id: "",
  user_email: "",
  // allowed_models
  temp: 0,
  chunk_size: 4,
  search_type: "similarity",
  chat_history: 0,
  model: "",
  type: "",
  request: "",
  sendfulldoc: false,
  piiInfo: false,
  hidePageContent: false,
};

export const userSlice = createSlice({
  name: "user",
  // `createSlice` will infer the state user from the `initialState` argument
  initialState,
  reducers: {
    addUserDetails: (state, action) => {
      return {
        ...action.payload,
        user_id: action.payload._id,
        // Ensure chat_history is set to default if not provided
        chat_history: action.payload.chat_history || 0,
      };
    },
    modifyChatHistory: (state, action) => {
      return {
        ...state,
        chat_history: action.payload,
      };
    },
    sendingfulldocument: (state, action) => {
      return {
        ...state,
        sendfulldoc: action.payload,
      };
    },
    sendingPiiInfo: (state, action) => {
      return {
        ...state,
        piiInfo: action.payload,
      };
    },
    hidePageContentToggle: (state, action) => {
      return {
        ...state,
        hidePageContent: action.payload,
      };
    },
  },
});

export const {
  addUserDetails,
  modifyChatHistory,
  sendingfulldocument,
  sendingPiiInfo,
  hidePageContentToggle,
} = userSlice.actions;

// Other code such as selectors can use the imported `RootState` user
export const getuser = (state: RootState) => state.user;
export const getChatHistory = (state: RootState) => state.user.chat_history;
export const getSendingFullDocument = (state: RootState) =>
  state.user.sendfulldoc;
export const getPIIInfo = (state: RootState) => state.user.piiInfo;
export const getHidePageContent = (state: RootState) =>
  state.user.hidePageContent;

export default userSlice.reducer;
